module.exports = __webpack_public_path__ + "static/visual_8_1_eg-fbf78377ffde2e730e9e62cec8e882bb.png";